import React, {
  useRef,
  Fragment,
  useContext,
  useState,
  useCallback,
  FocusEvent,
  KeyboardEvent,
} from "react";
import { useHistory } from "react-router-dom";

import {
  spaceCheck,
  emailCheck,
  isEmpty,
  serializeObject,
  callApi,
  setLocalStorage,
} from "bodycodi/cmap/app/js/common.js";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/cmap2020/scheduleDtlHeader";
import { InputLogin, InputBtn, InputWithTimer } from "bodycodi/cmap/app/components/cmap1010/input";
import { TimerSetting } from "bodycodi/cmap/app/components/common/timer";
import TernServicePop from "bodycodi/cmap/app/components/cmap1010/ternServicePop";
import join_succes from "bodycodi/cmap/app/img/join-succes.png";
import { api } from "bodycodi/cmap/app/js/api";
import useDeviceInfo from "bodycodi/cmap/app/hooks/useDeviceInfo";
import JoinBirthday from "bodycodi/cmap/app/components/cmap1010/joinBirthday";
import NameInput from "./NameInput";

JoinBirthday;
type joinStepType = {
  handleClose: () => void;
  allAgree: boolean;
  agreeMarketingYn: boolean;
};

type stepType = {
  authData?: any;
  setStep: Function;
  allAgree?: boolean;
  agreeMarketingYn?: boolean;
  seqMemberPhoneAuth?: number;
  setAuthData?: Function;
  mobile?: string;
  authNo?: string;
  name?: string;
  sex?: string;
  birthYear?: string;
};

type authType = {
  sendAuth: boolean;
  complete: boolean;
  seqMemberPhoneAuth: number;
};

type authDataType = {
  mobile: string;
  authNo: string;
  name: string;
  seqMemberPhoneAuth: number;
  sex: string;
  birthYear: string;
};

const Join = () => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [allAgree, setAllAgree] = useState(false);
  const [agreeMarketingYn, setAgreeMarketingYn] = useState(false);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "JOIN_POP", open: { joinPop: false } });
  };

  return (
    <Fragment>
      <CustomDialog open={state.joinPop} onClose={handleClose}>
        <JoinStep
          handleClose={handleClose}
          allAgree={allAgree}
          agreeMarketingYn={agreeMarketingYn}
        />
      </CustomDialog>
      <TernServicePop setAllAgree={setAllAgree} setAgreeMarketingYn={setAgreeMarketingYn} />
    </Fragment>
  );
};

const JoinStep = ({ handleClose, allAgree, agreeMarketingYn }: joinStepType) => {
  const [step, setStep] = useState<number>(1);
  const [authData, setAuthData] = useState<authDataType>({
    seqMemberPhoneAuth: 0,
    authNo: "",
    name: "",
    mobile: "",
    sex: "M",
    birthYear: "1990",
  });

  const clickClose = () => {
    if (step === 1 || step === 3) {
      handleClose();
    } else {
      setStep(1);
    }
  };

  return (
    <Fragment>
      {(step === 1 || step === 2) && (
        <PopupHeader
          title={step === 1 ? "본인인증 [1/2]" : "계정 생성 [2/2]"}
          rightIconType="close"
          onClickBack={handleClose}
          onClickRightIcon={clickClose}
        />
      )}
      {step === 1 && (
        <Fragment>
          <div className="popup-body join-pop">
            <SelfAuthentication setStep={setStep} authData={authData} setAuthData={setAuthData} />
          </div>
        </Fragment>
      )}
      {step === 2 && (
        <Fragment>
          <div className="popup-body join-pop">
            <CreateAccount
              setStep={setStep}
              allAgree={allAgree}
              agreeMarketingYn={agreeMarketingYn}
              {...authData}
            />
          </div>
        </Fragment>
      )}
      {step === 3 && (
        <div className="popup-body join-succes-pop">
          <WelcomePage />
        </div>
      )}
    </Fragment>
  );
};

const SelfAuthentication = ({ setStep, authData, setAuthData = () => ({}) }: stepType) => {
  const { dispatch } = useContext(DispatchContext);
  const btn = useRef<HTMLDivElement>(null);
  const form = useRef<HTMLDivElement>(null);
  const authBtn = useRef<HTMLDivElement>(null);
  const phoneNumberRef = useRef<HTMLInputElement>(null);
  const [auth, setAuth] = useState<authType>({
    complete: false,
    sendAuth: false,
    seqMemberPhoneAuth: 0,
  });
  const [timer, setTimer] = useState<TimerSetting>({
    end: false,
    refresh: 0,
    stop: false,
  });
  const [errorTextList, setErrorTextList] = useState<Array<string>>(["", "", "", ""]);
  const [succesText, setSuccesText] = useState<string>("");
  const [name, setName] = useState<string>("");

  const openAlert = (body: string, header: string) => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: false,
        redYn: false,
        header: header,
        body: body,
        cancelAlert: () => {
          return;
        },
        closeAlert: () => {
          return;
        },
      },
    });
  };

  const setEnd = useCallback(
    (bool: boolean) => {
      setTimer({ ...timer, end: bool });
    },
    [timer]
  );

  const nextStep = () => {
    if (auth.complete) {
      const data: any = serializeObject({ element: form.current });
      setAuthData((previousValue: any) => ({
        ...previousValue,
        seqMemberPhoneAuth: auth.seqMemberPhoneAuth,
        authNo: data.authNo,
        mobile: data.mobile,
        name: data.name,
      }));
      setStep(2);
    }
  };

  const checkCondition = useCallback(
    (i: number, e: FocusEvent<HTMLInputElement, Element>) => {
      const input = e.currentTarget as HTMLInputElement;
      if (i === 0) {
        if (isEmpty(input.value)) {
          errorTextList[i] = "이름을 입력해 주세요.";
        } else {
          errorTextList[i] = "";
        }
        setErrorTextList([...errorTextList]);
      } else if (i === 1) {
        if (isEmpty(input.value)) {
          errorTextList[i] = "휴대폰 전화번호를 입력해 주세요.";
        } else {
          errorTextList[i] = "";
        }
        setErrorTextList([...errorTextList]);
      }
    },
    [errorTextList]
  );

  const checkConditionWrap = useCallback(
    (i: number) => (e: FocusEvent<HTMLInputElement, Element>) => {
      checkCondition(i, e);
    },
    [errorTextList]
  );

  const requestSendAuth = () => {
    const data: any = serializeObject({ element: form.current });
    if (isEmpty(data.mobile)) {
      openAlert("휴대전화 번호를 입력해 주세요.", "회원가입");
      return;
    } else if (data.mobile.length < 10) {
      openAlert("올바른 휴대전화 번호를 입력해주세요.", "회원가입");
      return;
    } else if (isEmpty(data.name)) {
      openAlert("이름을 입력해주세요.", "회원가입");
      return;
    }
    callApi(
      "/cmap1010/execAuthNumSendSignIn",
      { mobile: data.mobile, name: data.name },
      "POST"
    ).then((res) => {
      const msgVO = res.MsgVO;
      const memberPhoneAuthVO = res.MemberPhoneAuthVO;
      if (msgVO.msgCd !== "CMAP1010-00") {
        openAlert(msgVO.msgCtnt, "휴대폰 기기 인증");
      } else {
        setAuth({
          ...auth,
          seqMemberPhoneAuth: memberPhoneAuthVO.seqMemberPhoneAuth,
          sendAuth: true,
        });
        setTimer({ ...timer, refresh: timer.refresh + 1, stop: false, end: false });
        dispatch({
          type: "UPDATE",
          data: { toast: true, toastText: "<span>인증번호가 전송되었습니다.</span>" },
        });
        setSuccesText("");
      }
    });
  };

  const blurAuth = (e: KeyboardEvent<HTMLInputElement>) => {
    const input = e.currentTarget as HTMLInputElement;
    const data: any = serializeObject({ element: form.current });
    if (input.value.length < 6) {
      authBtn.current?.classList.remove("active");
      errorTextList[2] = "인증번호를 6자리 입력해주세요";
      setErrorTextList([...errorTextList]);
      setSuccesText("");
      return;
    } else {
      authBtn.current?.classList.add("active");
      errorTextList[2] = "";
      setErrorTextList([...errorTextList]);
    }
  };

  const checkAuth = () => {
    const data: any = serializeObject({ element: form.current });
    if (timer.end) {
      //sendCrtfcation();
      //openAlert("인증 기간이 만료되었습니다. 인증번호를 다시 요청해 주세요.", "휴대폰 기기 인증");
      errorTextList[2] = "";
      setErrorTextList([...errorTextList]);
      setAuth({ ...auth, complete: false });
      setTimer({ ...timer, refresh: timer.refresh + 1, end: false, stop: false });
      setSuccesText("");
      return;
    }

    if (data.authNo.length === 6) {
      callApi(
        "/cmap1010/execAuthNumChkSignin",
        { seqMemberPhoneAuth: auth.seqMemberPhoneAuth, authNo: data.authNo },
        "POST"
      ).then((res) => {
        const msgVO = res.MsgVO;
        if (msgVO.msgCd !== "CMAP1010-00") {
          errorTextList[2] = msgVO.msgCtnt;
          setErrorTextList([...errorTextList]);
          setAuth({ ...auth, complete: false });
          setSuccesText("");
        } else {
          errorTextList[2] = "";
          setErrorTextList([...errorTextList]);
          setAuth({ ...auth, complete: true });
          setTimer({ ...timer, stop: true });
          setSuccesText("인증되었습니다.");
          phoneNumberRef.current!.readOnly = true;
        }
      });
    }
  };

  return (
    <div className="cmap1010-wrap">
      <div className="cmap1010-body" ref={form}>
        <NameInput
          label="이름"
          name="name"
          placeholder="본인 이름"
          onBlur={checkConditionWrap(0)}
          errorMsg={errorTextList[0]}
          value={name}
          onChange={setName}
        />

        <JoinBirthday authData={authData} setAuthData={setAuthData} />
        <InputBtn
          title="휴대전화 번호"
          type="tel"
          name="mobile"
          placeholder="- 없이 번호만 입력"
          onBlur={checkConditionWrap(1)}
          errorText={errorTextList[1]}
          ref={phoneNumberRef}
        >
          {auth.complete ? (
            <div className="btn">다시요청</div>
          ) : (
            <div className="btn active" onClick={requestSendAuth}>
              {auth.sendAuth ? "다시요청" : "인증요청"}
            </div>
          )}
        </InputBtn>
        {auth.sendAuth && (
          <InputWithTimer
            title="인증번호"
            type="tel"
            name="authNo"
            placeholder="6자리 인증 번호"
            {...timer}
            setEnd={setEnd}
            onKeyUp={blurAuth}
            errorText={errorTextList[2]}
            succesText={succesText}
          >
            {auth.complete ? (
              <div className="btn" ref={authBtn}>
                인증완료
              </div>
            ) : (
              <div className="btn active" ref={authBtn} onClick={checkAuth}>
                확인
              </div>
            )}
          </InputWithTimer>
        )}
      </div>
      <div className="cmap1010-footer">
        <div
          className={"cmap1010-btn" + (auth.complete ? " active" : "")}
          ref={btn}
          onClick={nextStep}
        >
          본인인증 완료
        </div>
      </div>
    </div>
  );
};

const CreateAccount = ({
  setStep,
  allAgree,
  agreeMarketingYn,
  seqMemberPhoneAuth,
  authNo,
  name,
  mobile,
  sex,
  birthYear,
}: stepType) => {
  const btn = useRef<HTMLDivElement>(null);
  const form = useRef<HTMLDivElement>(null);
  const [errorTextList, setErrorTextList] = useState<Array<string>>(["", "", "", ""]);
  const [succesText, setSuccesText] = useState<string>("");
  const [complete, setComplete] = useState<boolean>(false);
  const { dispatch } = useContext(DispatchContext);
  const { appToken, deviceOsCode, deviceName, deviceMacId } = useDeviceInfo();

  const openAlert = (body: string, header: string) => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: false,
        redYn: false,
        header: header,
        body: body,
        closeAlert: () => {
          return;
        },
        cancelAlert: () => {
          return;
        },
      },
    });
  };

  const checkCondition = useCallback(
    (i: number, e: FocusEvent<HTMLInputElement, Element>) => {
      const data: any = serializeObject({ element: form.current });

      if (isEmpty(data.email)) {
        errorTextList[0] = "이메일을 입력해 주세요.";
        setComplete(false);
      } else if (spaceCheck(data.email)) {
        errorTextList[0] = "이메일 앞뒤에 공백이 들어갈수 없습니다.";
        errorTextList[1] = "";
        errorTextList[2] = "";
        setComplete(false);
      } else if (emailCheck(data.email)) {
        errorTextList[0] = "유효한 형식의 이메일 아이디가 아닙니다.";
        errorTextList[1] = "";
        errorTextList[2] = "";
        setComplete(false);
      } else if (isEmpty(data.password)) {
        errorTextList[1] = "비밀번호를 입력해 주세요.";
        errorTextList[0] = "";
        errorTextList[2] = "";
        setComplete(false);
      } else if (spaceCheck(data.password)) {
        errorTextList[1] = "비밀번호 앞뒤에 공백이 들어갈수 없습니다.";
        errorTextList[0] = "";
        errorTextList[2] = "";
        setComplete(false);
      } else if (data.password.length < 8) {
        errorTextList[1] = "비밀번호를 8글자 이상 입력해 주세요.";
        errorTextList[0] = "";
        errorTextList[2] = "";
        setComplete(false);
      } else if (!(data.password.match(/[a-zA-Z]/g) && data.password.match(/[0-9]/g))) {
        errorTextList[1] = "영문, 숫자 포함 8글자이상 입력해 주세요.";
        errorTextList[0] = "";
        errorTextList[2] = "";
        setComplete(false);
      } else if (isEmpty(data.passwordConfirm)) {
        errorTextList[2] = "비밀번호 확인을 입력해 주세요.";
        errorTextList[1] = "";
        errorTextList[0] = "";
        setComplete(false);
        setSuccesText("");
      } else if (data.passwordConfirm.length < 8) {
        errorTextList[2] = "비밀번호 확인를 8글자 이상 입력해 주세요.";
        errorTextList[1] = "";
        errorTextList[0] = "";
        setComplete(false);
        setSuccesText("");
      } else if (data.password !== data.passwordConfirm) {
        errorTextList[2] = "비밀번호와 비밀번호 확인이 일치하지 않습니다.";
        errorTextList[1] = "";
        errorTextList[0] = "";
        setComplete(false);
        setSuccesText("");
      } else {
        errorTextList[0] = "";
        errorTextList[1] = "";
        errorTextList[2] = "";
        setSuccesText("비밀번호가 일치합니다.");
        setComplete(true);
      }
      setErrorTextList([...errorTextList]);
    },
    [errorTextList]
  );

  const checkConditionWrap = useCallback(
    (i: number) => (e: FocusEvent<HTMLInputElement, Element>) => {
      checkCondition(i, e);
    },
    [checkCondition]
  );

  const clickJoin = () => {
    if (complete) {
      const data: any = serializeObject({ element: form.current });
      if (allAgree) {
        if (agreeMarketingYn) {
          data.agreeMarketingYn = "Y";
        } else {
          data.agreeMarketingYn = "N";
        }
        data.password = data.password.trim();
        data.mobile = mobile;
        data.name = name;
        data.sex = sex;
        data.birthYear = birthYear;
        data.appToken = appToken;
        data.deviceOsCode = deviceOsCode;
        data.deviceName = deviceName;
        data.deviceMacId = deviceMacId;

        callApi("/cmap1010/execSignIn", { ...data }, "POST").then(
          ({ MsgVO, accessToken, seqMobileMembers, seqManagerMobileDevice }) => {
            if (MsgVO.msgCd === "CMAP1010-00") {
              api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
              setLocalStorage("accessToken", accessToken);
              setLocalStorage("seqMobileMembers", seqMobileMembers);
              setLocalStorage("seqManagerMobileDevice", seqManagerMobileDevice);
              setStep(3);
            } else {
              openAlert(MsgVO.msgCtnt, "회원가입");
            }
          }
        );
      }
    }
  };

  return (
    <div className="cmap1010-wrap">
      <div className="cmap1010-body" ref={form}>
        <InputLogin
          title="이메일 아이디"
          type="email"
          name="email"
          placeholder="이메일 입력"
          onBlur={checkConditionWrap(0)}
          errorText={errorTextList[0]}
        />
        <InputLogin
          title="비밀번호"
          type="password"
          name="password"
          placeholder="영문, 숫자 포함 8글자이상"
          onBlur={checkConditionWrap(1)}
          errorText={errorTextList[1]}
        />
        <InputLogin
          title="비밀번호 확인"
          type="password"
          name="passwordConfirm"
          placeholder="영문, 숫자 포함 8글자이상"
          onBlur={checkConditionWrap(2)}
          errorText={errorTextList[2]}
          succesText={succesText}
        />
      </div>
      <div className="cmap1010-footer">
        <div className={"cmap1010-btn" + (complete ? " active" : "")} ref={btn} onClick={clickJoin}>
          회원가입
        </div>
      </div>
    </div>
  );
};

const WelcomePage = () => {
  const history = useHistory();

  const click = () => {
    history.replace("/home");
  };

  return (
    <div className="cmap1010-wrap">
      <div className="cmap1010-body join-succes">
        <img src={join_succes} />
        <div className="text">
          바디코디 강사 앱으로
          <br />
          편하게 스케줄을 예약관리하고
          <br />
          회원님들과 소통해보세요!
        </div>
      </div>
      <div className="cmap1010-footer">
        <div className="cmap1010-btn active" onClick={click}>
          바디코디 강사 앱 시작하기
        </div>
      </div>
    </div>
  );
};

export default Join;
